export default function userData(
    state = {
        userData: {
            firstName: '',
            lastName: '',
            email: '',
            internalUserId: '',
            phones: [
                {
                    countryCode: 'US',
                    number: '',
                },
            ],
        },
        auth: {
            uuid: '',
            token: '',
        },
        featureFlags: {
            enableAxleForm: false,
        },
        error: null,
    },
    {type, payload}
) {
    switch (type) {
        case 'TOKEN': {
            return {
                ...state,
                token: payload,
            };
        }
        case 'AUTH': {
            return {
                ...state,
                auth: payload,
            };
        }
        case 'USER_DATA': {
            return {
                ...state,
                userData: {
                    ...state.userData,
                    ...payload,
                },
                fetched: true,
            };
        }
        case 'SET_FEATURE_FLAGS': {
            return {
                ...state,
                featureFlags: {
                    ...state.featureFlags,
                    ...payload,
                },
            };
        }
        case 'VIEW': {
            return {
                ...state,
                view: payload,
            };
        }
        case 'ERROR': {
            return {
                ...state,
                error: payload,
            };
        }
        default:
            return state;
    }
}
